const constants = {
	datetimeFormats: {
		date: 'MM/DD/YYYY',
		dateTime: 'MM/DD/YYYY hh:mm A',
		hyphenSeparatedDateTime: "MM-DD-YYYY | hh:mm A"
	},
	dateFormats: {
		slashSeparatedDate: "DD/MM/YYYY",
		hyphenSeparatedDate: "MM-DD-YYYY",
		databaseFormat: "YYYY-MM-DD",
		YearOrMonth: "YYYY-MM"
	},
	timeFormats: {
		timeIn24HoursFormat: "HH:mm:ss",
		timeIn12HoursFormat: "hh:mm A",
	},
	channelOptions: [
		{ label: 'All Channels', value: 'all' },
		{ label: 'Amazon.com', value: 'AMAZON.COM', disabled: false },
		{ label: 'Amazon.ca', value: 'AMAZON.CA', disabled: false },
		{ label: 'Shopify', value: 'SHOPIFY', disabled: false },
		{ label: 'Walmart', value: 'WALMART', disabled: false },
		{ label: 'Custom', value: 'CUSTOM', disabled: false }
	],
	statusOptions: [
		{ label: 'All Status', value: 3 },
		{ label: 'Active', value: 1 },
		{ label: 'Inactive', value: 2 }
	],
	typeOptions: [
		{ label: 'Physical', value: 'physical' },
		{ label: 'Virtual', value: 'virtual' }
	],
	productTypeOptions: [
		{ label: 'All Types', value: 'All' },
		{ label: 'Core', value: 'Core' },
		{ label: 'Bundle', value: 'Bundle' },
	],
	createProductOptions: [
		{ label: 'Core Product', value: 'Core' },
		{ label: 'Bundled/Kit', value: 'Bundle' }
	],
	shipmentOptions: [
		{ label: 'Awaiting Payment', value: 8},
        { label: 'Awaiting Shipment', value: 1 },
		{ label: 'Shipment In Progress', value: 9 },
        { label: 'Unresolved', value: 2 },
        { label: 'On Hold', value: 3 },
        { label: 'Shipped', value: 4 },
        { label: 'Cancelled', value: 5 },
        // { label: 'Voided', value: 7 },
    ],
	unresolvedShipmentOptions: [
		// { label: 'All Status', value: 'all' },
        { label: 'Out of Stock', value: 2 },
        { label: 'Product Info Missing', value: 3 },
        { label: 'Order Info Missing', value: 4 },
    ],
	shippedShipmentOptions: [
		{ label: 'All Status', value: 'all' },
        { label: 'Awaiting Delivery', value: 1 },
        { label: 'Delivered', value: 2 },
        { label: 'Voided', value: 3 }
    ],
	fullfillmentShipmentOptions: [
        { label: 'FBA', value: 2 },
		{ label: 'FBM', value: 1 },
        { label: 'WFS', value: 5 },
		{ label: 'WFM', value: 4 },
        { label: 'Shopify', value: 3 },
		{ label: 'Manual', value: 0 }
    ],
    warehousesOptions: [
        { label: 'All Warehouses', value: 'all' },
        { label: 'Warehouses 1', value: 'Warehouses 1' },
        { label: 'Warehouses 2', value: 'Warehouses 2' },
    ],
	purchaseOrderStatus: [
		{ label: 'Awaiting Authorization', value: 1, name: 'AWAITING_AUTHORIZATION' },
		{ label: 'Awaiting Vendor Confirmation', value: 2, name: 'AWAITING_VENDOR_CONFIRMATION' },
		{ label: 'Awaiting Re-Authorization', value: 3, name: 'AWAITING_RE_AUTHORIZATION' },
		{ label: 'Pending Delivery', value: 4, name: 'PENDING_DELIVERY' },
		{ label: 'Partially Delivered', value: 5, name: 'PARTIAL_DELIVERY' },
		{ label: 'Fulfilled', value: 6, name: 'FULFILLED' },
		{ label: 'Closed Short', value: 7, name: 'CLOSE_SHORT' },
		{ label: 'Voided', value: 8, name: 'VOIDED' }
	],
	purchaseOrderActions: [
		{ name: 'Authorize PO', value: 'AUTHORIZE_PO' },
		{ name: 'Re-Authorize PO', value: 'RE_AUTHORIZE_PO' },
		{ name: 'Confirm', value: 'CONFIRM' },
		{ name: 'Receive', value: 'RECEIVE' },
		{ name: 'Resend', value: 'RESEND' },
		{ name: 'Print Proforma', value: 'PRINT_PROFORMA' },
		{ name: 'Print Pending Items', value: 'PRINT_PENDING_ITEMS' },
		{ name: 'Export PO', value: 'EXPORT_PO' },
		{ name: 'Void PO', value: 'VOID_PO' },
	],
	discountTypes: [
		{ label: '$', value: 'price' },
		{ label: '%', value: 'percentage' }
	],
	PO_TYPES_OPTIONS: [
		{ label: 'Each', value: 'Each' },
		{ label: 'Master', value: 'Master' },
	],
	PO_ORDER_AS_OPTIONS: [
		{ label: 'Bundle', value: 'bundle' },
		{ label: 'Core', value: 'core' },
	],
	inventoryStatusOptions: [
		{ label: 'All Status', value: 3 },
		{ label: 'Satisfactory Stock', value: 1 },
		{ label: 'Out of Stock', value: 2 }
	],
	orderActions: [
		{ name: 'Print Pick List', value: 'PRINT_PICK_LIST' },
		{ name: 'Print Packing Slip', value: 'PRINT_PACKING_SLIP' },
		{ name: 'Export Orders', value: 'EXPORT_ORDERS' },
		{ name: 'Export Order', value: 'EXPORT' },
		{ name: 'Ship Orders', value: 'SHIP_ORDERS' },
		{ name: 'Cancel Orders', value: 'CANCEL' },
		{ name: 'Shipment Label', value: 'DOWNLOAD_LABEL' },
		{ name: 'Return Label', value: 'RETURN_LABEL' },
	],
	shipmentActions: [
		{ name: 'Print Pick List', value: 'PRINT_PICK_LIST' },
		{ name: 'Print Packing Slip', value: 'PRINT_PACKING_SLIP' },
		{ name: 'Export Order', value: 'EXPORT_SHIPMENTS' },
		{ name: 'Export Shipment', value: 'EXPORT_SHIPMENTS' },
		{ name: 'Export Shipments', value: 'EXPORT' },
		{ name: 'Void Shipment', value: 'VOID_SHIPMENT' },
		{ name: 'Shipment Label', value: 'DOWNLOAD_LABEL' },
		{ name: 'Return Label', value: 'RETURN_LABEL' },
	],
	shipmentStatusOptions: [
		{ label: 'All Status', value: 3 },
		{ label: 'Shipped', value: 4 },
		// { label: 'Voided', value: 7 }
	],
	confirmationStatusOptions: [
		{ label: 'No Confirmation', value: 'none' },
		{ label: 'Delivery', value: 'delivery' },
		{ label: 'Signature', value: 'signature' },
		{ label: 'Adult Signature', value: 'adult_signature' },
		{ label: 'Direct Signature', value: 'direct_signature' },
		{ label: 'Delivery Mailed', value: 'delivery_mailed' },
		{ label: 'Verbal Confirmation', value: 'verbal_confirmation' }
	],
	DEFAULT_WAREHOUSE_NAME: "Mixt Main Warehouse",
	OUTLYING_AREAS_OF_US: [
		'AA', 
		'AP', 
		'AE',
		'GU'
	],
	KEYS: {
		KEY_ENTER: 'enter'
	},
	CHANNELS: {
		MANUAL: 'MANUAL',
		FBA: 'FBA'
	}
};

export default constants;